export const homeTranslations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      journals: "Our Journals",
      procedure: "Publication Procedure",
      benefits: "Benefits",
      guidelines: "Guidelines",
      policies: "Policies",
      contact: "Contact Us",
      contactBtn: "Contact Us",
      contactMobile: "Contact",
      editorialOffice: "Contact Editorial Office",
      selectLanguage: "Select Language",
      navigation: "Navigation",
      fastTrack: "Fast-Track Peer Review"
    },
    hero: {
      trustPill: "Peer-Reviewed & Open Access Publisher",
      titleMain: "Publish Your Research with",
      titleAccent: "Global Impact",
      titleEnd: "& Confidence",
      subtitle: "Join thousands of international authors and researchers who trust our peer-reviewed journals. Experience fast-track double-blind review, DOI assignment, and worldwide scholarly indexing.",
      contactBtn: "Contact Editorial Office",
      browseBtn: "Browse Our Journals",
      stats: {
        journals: "Scholarly Journals",
        countries: "Countries Reached",
        review: "Fast Peer-Review",
        openAccess: "Open Access"
      }
    },
    about: {
      sectionTitle: "About Us",
      highlight: "A Dubai-based independent academic publisher dedicated to advancing research, innovation, and scholarly excellence. We serve as a trusted platform for researchers, professors, and professionals who seek global visibility for their work.",
      description1: "Arc Publication Services LLC is an independent publisher dedicated to facilitating researchers, academics, and professionals in publishing their quality research. We offer a variety of peer-reviewed open access publishing venues. With a commitment to ethical conduct, transparency, academic integrity, and accessibility, Arc aids important research in reaching broader academic audiences, thus promoting the exchange of knowledge.",
      description2: "With a strong commitment to open access, global indexing, and timely publication, we empower researchers to share their knowledge without barriers, fostering innovation and collaboration across disciplines."
    },
    mission: {
      title: "Our Mission",
      points: [
        "To maintain excellence in academic publishing.",
        "To maintain integrity in the peer review process.",
        "To provide researchers with an excellent platform for publishing.",
        "To promote quality and valuable research all over the world."
      ]
    },
    vision: {
      title: "Our Vision",
      points: [
        "To be a credible and respectable international academic publishing house.",
        "To foster lifelong learning and research.",
        "To make scholarly research more accessible and visible.",
        "To forge academic relationships across borders."
      ]
    },
    areasCovered: {
      badge: "Academic Disciplines",
      titleMain: "Areas We Cover",
      titleAccent: "Cover",
      intro: "ARC Publication Services LLC offers researchers, academics, and professionals a way of publishing their research works through an open access medium. Our expanding repertoire features contributions drawn from various fields of academia that have been useful in making unique contributions towards innovation and knowledge sharing.",
      items: [
        {
          title: "Health and Medical Sciences",
          description: "Studies involving medical science, healthcare, medicine, diseases, therapy and advancements within the field of health sciences."
        },
        {
          title: "Nephrology and Urology",
          description: "Studies concentrating on the kidneys, kidney diseases, urology and advancements within nephrology and urology."
        },
        {
          title: "Applied Sciences",
          description: "Studies involving the application of science, discoveries, technological advancements and solutions to practical problems."
        },
        {
          title: "Natural Sciences",
          description: "Studies dealing with scientific research, discovery and advancements that lead to greater insight into the natural world."
        },
        {
          title: "Education and Educational Studies",
          description: "Studies concerned with educational theory, pedagogy, education, policies, development and new challenges in education."
        },
        {
          title: "Interdisciplinary Research",
          description: "Research which involves many academic disciplines to form broad viewpoints and solve problems creatively."
        },
        {
          title: "Multidisciplinary Research",
          description: "Research which integrates different academic disciplines to facilitate collaboration and exchange of knowledge."
        },
        {
          title: "Emerging Research Fields",
          description: "Innovative research in new fields that help scientific, academic, professional and social progress is welcome at ARC Publication Services LLC."
        }
      ],
      statementTitle: "Diverse Research Formats Welcome",
      statementText1: "We are pleased to publish new research contributions in all of our journals that can be theoretical, empirical, review-oriented, applied research or research that presents new ideas, practical insights, and academic contributions.",
      statementText2: "ARC Publication Services LLC is an open-access academic platform where scholars exchange information, cross-reference ideas and promote the progress of academia.",
      inquireBtn: "Submit / Inquire Now"
    },
    ourJournal: {
      title: "Our Journal",
      intro: "ARC Publication Services LLC hosts a growing portfolio of peer-reviewed journals spanning multiple academic disciplines. Each journal is guided by expert editorial boards and indexed in leading databases to maximize visibility and impact.",
      provideTitle: "Our journals provide:",
      provideList: [
        "Rigorous double-blind peer review",
        "DOI assignment for all articles",
        "Open access for global readership",
        "Opportunities for special issues and conference collaborations"
      ],
      closing: "Whether you are a professor, researcher, or industry professional, our journals are the right platform to showcase your work.",
      moreJournals: "More Journals",
      viewJournal: "View Journal",
      submitPaper: "Submit Paper"
    },
    procedure: {
      title: "Our Publication Process",
      subtitle: "A transparent path from manuscript submission to scholarly publication",
      steps: [
        {
          title: "Manuscript Submission",
          description: "The authors submit their research papers according to the set guidelines along with the necessary documentation."
        },
        {
          title: "Editorial Screening",
          description: "The editorial board reviews the submitted paper to ascertain its relevance, quality, formatting, originality, and suitability for peer review."
        },
        {
          title: "Double-Blind Peer Review",
          description: "The paper undergoes evaluation by subject experts through a double-blind peer review process to assess its originality and academic quality."
        },
        {
          title: "Revisions & Decision",
          description: "The author considers the reviewers' feedback and makes the necessary revisions. After revision, the editors make the final decision regarding publication."
        },
        {
          title: "Publication & Accessibility",
          description: "Once the paper is accepted, it undergoes the publication process and becomes accessible to everyone."
        }
      ],
      comprehensiveSupport: {
        title: "Comprehensive Support Services",
        col1: [
          "Language editing and proofreading services",
          "Plagiarism checks and similarity reports",
          "Formatting assistance to meet journal standards"
        ],
        col2: [
          "Expert guidance on responding to reviewer comments",
          "Professional illustration and figure preparation",
          "Post-publication impact tracking and analytics"
        ]
      }
    },
    benefits: {
      title: "Benefits of Publishing With Us",
      subtitle: "Why researchers around the world choose ARC Publication Services LLC",
      list: [
        "Transparent and fair peer review process by international experts",
        "Rapid yet rigorous publication process with quick turnaround times",
        "International indexing in major databases (Scopus, DOAJ, Google Scholar, etc.)",
        "Dedicated author support at every stage of publication",
        "Open Access with Creative Commons licenses for maximum visibility",
        "Professional language editing and typesetting services",
        "Digital Object Identifier (DOI) assignment for each published article",
        "Multidisciplinary platform covering diverse research areas",
        "Monthly publication frequency for timely dissemination of research",
        "Affordable publication charges with no hidden fees",
        "Global readership and increased citation potential",
        "Complimentary e-certificate and hard copy of published issues",
        "UGC-CARE and other major indexing compliance",
        "Multilingual support for international authors"
      ]
    },
    partners: {
      title: "Indexed In & Partners"
    },
    faqs: {
      title: "Frequently Asked Questions",
      list: [
        {
          question: "How can I submit my research paper to ARC Publication?",
          answer: "You can submit your paper through the official submission method given by the ARC Publication journal."
        },
        {
          question: "What types of research does ARC Publication accept?",
          answer: "ARC Publication accepts original research, review papers, and other research work that matches the journal’s subject area."
        },
        {
          question: "How does the peer-review process work at ARC Publication?",
          answer: "First, the editor checks your paper. Then, experts review it through a double-blind peer-review process."
        },
        {
          question: "How long does ARC Publication take to publish a research paper?",
          answer: "The time depends on the journal, review process, author revisions, and final editorial decision."
        },
        {
          question: "Does ARC Publication provide open-access publication?",
          answer: "Yes, ARC Publication provides open-access publishing so readers can easily access published research."
        },
        {
          question: "How can I check whether my research fits an ARC Publication journal?",
          answer: "Check the journal’s subject area, scope, and author guidelines before submitting your paper."
        },
        {
          question: "What support does ARC Publication provide to authors?",
          answer: "ARC Publication offers help with language editing, proofreading, formatting, plagiarism checks, reviewer responses, and figure preparation."
        },
        {
          question: "Can I submit a manuscript that has been published elsewhere?",
          answer: "No. Your manuscript should be original and should not be published or submitted to another journal at the same time."
        },
        {
          question: "Does ARC Publication check manuscripts for plagiarism?",
          answer: "Yes, ARC Publication provides plagiarism and similarity checking to help maintain the quality and originality of research."
        },
        {
          question: "Can authors request help with manuscript formatting?",
          answer: "Yes, authors can get formatting support to prepare their manuscript according to the journal’s requirements."
        }
      ]
    },
    footer: {
      tagline: "Advancing Research and Collaboration in Academic Publishing",
      quickLinks: "Quick Links",
      aboutUs: "About Us",
      guidelines: "Guidelines",
      policies: "Policies",
      contactUs: "Contact Us",
      submitPaper: "Submit Paper",
      address: "Office No 118, SHAIKHA MHARA-AL, QUSAIS BLDG, Al Qusais Second, Dubai, 00000, Dubai",
      letsChat: "Let's Chat",
      haveQuestion: "Have a support question?",
      getInTouch: "Get in Touch",
      copyright: "© 2026 Arc Publication Services LLC. All rights reserved."
    }
  },

  hi: {
    nav: {
      home: "होम",
      about: "हमारे बारे में",
      journals: "हमारे जर्नल्स",
      procedure: "प्रकाशन प्रक्रिया",
      benefits: "लाभ",
      guidelines: "दिशानिर्देश",
      policies: "नीतियां",
      contact: "संपर्क करें",
      contactBtn: "संपर्क करें",
      contactMobile: "संपर्क",
      editorialOffice: "संपादकीय कार्यालय से संपर्क करें",
      selectLanguage: "भाषा चुनें",
      navigation: "नेविगेशन",
      fastTrack: "फास्ट-ट्रैक सहकर्मी समीक्षा"
    },
    hero: {
      trustPill: "सहकर्मी-समीक्षित और ओपन एक्सेस प्रकाशक",
      titleMain: "अपने शोध को",
      titleAccent: "वैश्विक प्रभाव",
      titleEnd: "और विश्वास के साथ प्रकाशित करें",
      subtitle: "हजारों अंतरराष्ट्रीय शोधकर्ताओं और लेखकों से जुड़ें जो हमारी सहकर्मी-समीक्षित पत्रिकाओं पर भरोसा करते हैं। त्वरित डबल-ब्लाइंड समीक्षा, डीओआई असाइनमेंट और वैश्विक इंडेक्सिंग का अनुभव करें।",
      contactBtn: "संपादकीय कार्यालय से संपर्क करें",
      browseBtn: "हमारे जर्नल्स देखें",
      stats: {
        journals: "विद्वतापूर्ण पत्रिकाएं",
        countries: "देशों तक पहुंच",
        review: "त्वरित सहकर्मी समीक्षा",
        openAccess: "खुला उपयोग"
      }
    },
    about: {
      sectionTitle: "हमारे बारे में",
      highlight: "एआरसी पब्लिकेशन सर्विसेज एलएलसी एक स्वतंत्र प्रकाशक है, जो शोधकर्ताओं, शिक्षाविदों और पेशेवरों को अपने गुणवत्तापूर्ण शोध को प्रकाशित करने में सहायता करने के लिए समर्पित है। हम विभिन्न सहकर्मी-समीक्षित ओपन एक्सेस प्रकाशन मंच प्रदान करते हैं। ",
      description1: "नैतिक आचरण, पारदर्शिता, शैक्षणिक ईमानदारी और पहुंच के प्रति प्रतिबद्धता के साथ, ARC महत्वपूर्ण शोध को व्यापक शैक्षणिक दर्शकों तक पहुंचाने में सहायता करता है और इस प्रकार ज्ञान के आदान-प्रदान को बढ़ावा देता है।",
      description2: "ओपन एक्सेस, वैश्विक इंडेक्सिंग और समय पर प्रकाशन के प्रति मजबूत प्रतिबद्धता के साथ, हम शोधकर्ताओं को बिना किसी बाधा के ज्ञान साझा करने में सक्षम बनाते हैं।"
    },
    mission: {
      title: "हमारा उद्देश्य (मिशन)",
      points: [
        "अकादमिक प्रकाशन में उत्कृष्टता बनाए रखना।",
        "सहकर्मी समीक्षा प्रक्रिया में ईमानदारी बनाए रखना।",
        "शोधकर्ताओं को प्रकाशन के लिए एक उत्कृष्ट मंच प्रदान करना।",
        "गुणवत्तापूर्ण और मूल्यवान शोध को पूरे विश्व में बढ़ावा देना।"
      ]
    },
    vision: {
      title: "हमारा दृष्टिकोण (विज़न)",
      points: [
        "एक विश्वसनीय और सम्मानित अंतरराष्ट्रीय अकादमिक प्रकाशन संस्था बनना।",
        "आजीवन सीखने और शोध को बढ़ावा देना।",
        "विद्वत्तापूर्ण शोध को अधिक सुलभ और दृश्यमान बनाना।",
        "सीमाओं के पार अकादमिक संबंध स्थापित करना।"
      ]
    },
    areasCovered: {
      badge: "अकादमिक विषय क्षेत्र",
      titleMain: "हमारे द्वारा कवर किए जाने वाले ",
      titleAccent: "क्षेत्र",
      intro: "एआरसी पब्लिकेशन सर्विसेज एलएलसी शोधकर्ताओं, शिक्षाविदों और पेशेवरों को ओपन एक्सेस माध्यम के द्वारा अपने शोध कार्य प्रकाशित करने का अवसर प्रदान करता है। हमारे विस्तारित प्रकाशन क्षेत्र में अकादमिक जगत के विभिन्न क्षेत्रों से योगदान शामिल हैं, जो नवाचार और ज्ञान के आदान-प्रदान में विशिष्ट योगदान देने में सहायक रहे हैं।",
      items: [
        {
          title: "स्वास्थ्य और चिकित्सा विज्ञान",
          description: "चिकित्सा विज्ञान, स्वास्थ्य सेवा, चिकित्सा, रोगों, उपचार तथा स्वास्थ्य विज्ञान के क्षेत्र में होने वाली प्रगति से संबंधित अध्ययन।"
        },
        {
          title: "नेफ्रोलॉजी और यूरोलॉजी",
          description: "गुर्दों, गुर्दे से संबंधित रोगों, यूरोलॉजी तथा नेफ्रोलॉजी के क्षेत्र में होने वाली प्रगति पर केंद्रित अध्ययन।"
        },
        {
          title: "अंतरविषयक शोध (Applied Sciences)",
          description: "विज्ञान के अनुप्रयोग, खोजों, तकनीकी प्रगति तथा व्यावहारिक समस्याओं के समाधान से संबंधित अध्ययन।"
        },
        {
          title: "बहुविषयक शोध(Natural Sciences)",
          description: "वैज्ञानिक शोध, खोज और प्रगति से संबंधित अध्ययन, जो प्राकृतिक दुनिया की बेहतर समझ विकसित करने में सहायक हों।"
        },
        {
          title: "शिक्षा और शैक्षिक अध्ययन",
          description: "वैज्ञानिक शोध, खोज और प्रगति से संबंधित अध्ययन, जो प्राकृतिक दुनिया की बेहतर समझ विकसित करने में सहायक हों।"
        },
        {
          title: "अंतरविषयक शोध (Interdisciplinary)",
          description: "व्यापक दृष्टिकोण बनाने और रचनात्मक रूप से समस्याओं को हल करने के लिए कई विषयों को शामिल करने वाला शोध।"
        },
        {
          title: "बहुविषयक शोध (Multidisciplinary)",
          description: "सहयोग और ज्ञान के आदान-प्रदान को सुविधाजनक बनाने के लिए विभिन्न शैक्षणिक विषयों को एकीकृत करने वाला शोध।"
        },
        {
          title: "उभरते हुए शोध क्षेत्र",
          description: "नए क्षेत्रों में नवीन अनुसंधान जो वैज्ञानिक, शैक्षणिक, व्यावसायिक और सामाजिक प्रगति में सहायक हों।"
        }
      ],
      statementTitle: "विविध शोध प्रारूपों का स्वागत है",
      statementText1: "हमें अपने सभी जर्नलों में नए शोध योगदान प्रकाशित करने में प्रसन्नता होती है। इनमें सैद्धांतिक, अनुभवजन्य, समीक्षा-आधारित, अनुप्रयुक्त शोध या ऐसे शोध शामिल हो सकते हैं, जो नए विचार, व्यावहारिक अंतर्दृष्टि और अकादमिक योगदान प्रस्तुत करते हैं।",
      statementText2: "एआरसी पब्लिकेशन सर्विसेज एलएलसी एक ओपन-एक्सेस अकादमिक मंच है, जहाँ विद्वान जानकारी का आदान-प्रदान करते हैं, विचारों का संदर्भ देते हैं और अकादमिक प्रगति को बढ़ावा देते हैं।",
      inquireBtn: "प्रस्तुत करें / अभी पूछताछ करें"
    },
    ourJournal: {
      title: "हमारे जर्नल",
      intro: "एआरसी पब्लिकेशन सर्विसेज एलएलसी कई शैक्षणिक विषयों में फैले सहकर्मी-समीक्षित पत्रिकाओं के बढ़ते पोर्टफोलियो की मेजबानी करता है। प्रत्येक पत्रिका विशेषज्ञ संपादकीय बोर्डों द्वारा निर्देशित होती है और दृश्यता व प्रभाव को अधिकतम करने के लिए प्रमुख डेटाबेस में अनुक्रमित होती है।",
      provideTitle: "हमारी पत्रिकाएं प्रदान करती हैं:",
      provideList: [
        "कठोर डबल-ब्लाइंड सहकर्मी समीक्षा",
        "सभी शोध लेखों के लिए DOI आवंटन",
        "वैश्विक पाठकों के लिए ओपन एक्सेस",
        "विशेष अंकों और सम्मेलन सहयोग के अवसर"
      ],
      closing: "चाहे आप प्रोफेसर हों, शोधकर्ता हों, या उद्योग पेशेवर हों, हमारे जर्नल आपके काम को प्रदर्शित करने के लिए सही मंच हैं।",
      moreJournals: "अधिक जर्नल्स",
      viewJournal: "जर्नल देखें",
      submitPaper: "पेपर जमा करें"
    },
    procedure: {
      title: "हमारी प्रकाशन प्रक्रिया",
      subtitle: "पांडुलिपि प्रस्तुत करने से लेकर विद्वतापूर्ण प्रकाशन तक एक पारदर्शी मार्ग",
      steps: [
        {
          title: "पांडुलिपि प्रस्तुत करना",
          description: "लेखक निर्धारित दिशानिर्देशों के अनुसार आवश्यक दस्तावेजों के साथ अपने शोध पत्र जमा करते हैं।"
        },
        {
          title: "संपादकीय स्क्रीनिंग",
          description: "संपादकीय बोर्ड प्रस्तुत शोध पत्र की प्रासंगिकता, गुणवत्ता, प्रारूप, मौलिकता और सहकर्मी समीक्षा के लिए उसकी उपयुक्तता का मूल्यांकन करता है।"
        },
        {
          title: "डबल-ब्लाइंड सहकर्मी समीक्षा",
          description: "शोध पत्र की मौलिकता और अकादमिक गुणवत्ता का मूल्यांकन करने के लिए संबंधित विषय के विशेषज्ञों द्वारा डबल-ब्लाइंड सहकर्मी समीक्षा की जाती है।"
        },
        {
          title: "संशोधन और निर्णय",
          description: "लेखक समीक्षकों द्वारा दिए गए सुझावों पर विचार करते हैं और शोध पत्र में आवश्यक संशोधन करते हैं। संशोधित शोध पत्र प्राप्त होने के बाद संपादक उसके प्रकाशन के संबंध में अंतिम निर्णय लेते हैं।"
        },
        {
          title: "प्रकाशन और पहुंच",
          description: "जब शोध पत्र स्वीकार कर लिया जाता है, तो वह प्रकाशन प्रक्रिया से गुजरता है और सभी के लिए उपलब्ध हो जाता है।"
        }
      ],
      comprehensiveSupport: {
        title: "व्यापक सहायता सेवाएँ",
        col1: [
          "भाषा संपादन और प्रूफरीडिंग सेवाएँ",
          "साहित्यिक चोरी (प्लगीयरिज़्म) जाँच और समानता रिपोर्ट",
          "जर्नल मानकों के अनुरूप फ़ॉर्मेटिंग सहायता"
        ],
        col2: [
          "समीक्षकों की टिप्पणियों का उत्तर देने पर विशेषज्ञ मार्गदर्शन",
          "पेशेवर चित्रण और चित्र (फ़िगर) निर्माण",
          "प्रकाशन के बाद प्रभाव ट्रैकिंग और विश्लेषण"
        ]
      }
    },
    benefits: {
      title: "हमारे साथ प्रकाशित करने के लाभ",
      subtitle: "दुनिया भर के शोधकर्ता आर्क पब्लिकेशन सर्विसेज एलएलसी को क्यों चुनते हैं",
      list: [
        "अंतरराष्ट्रीय विशेषज्ञों द्वारा पारदर्शी और निष्पक्ष समीक्षा प्रक्रिया",
        "कम समय में त्वरित और कठोर प्रकाशन प्रक्रिया",
        "प्रमुख अंतरराष्ट्रीय डेटाबेस (Scopus, DOAJ, Google Scholar आदि) में इंडेक्सिंग",
        "प्रकाशन के प्रत्येक चरण में समर्पित लेखक सहायता",
        "अधिकतम दृश्यता के लिए क्रिएटिव कॉमन्स लाइसेंस के साथ ओपन एक्सेस",
        "व्यावसायिक भाषा संपादन और टाइपसेटिंग सेवाएं",
        "प्रत्येक प्रकाशित लेख के लिए डिजिटल ऑब्जेक्ट आइडेंटिफ़ायर (DOI)",
        "विविध शोध क्षेत्रों को कवर करने वाला बहु-विषयक मंच",
        "अनुसंधान के त्वरित प्रसार के लिए मासिक प्रकाशन",
        "बिना किसी छिपे शुल्क के वहनीय प्रकाशन शुल्क",
        "वैश्विक पाठक वर्ग और उद्धरण (Citation) क्षमता में वृद्धि",
        "निःशुल्क ई-प्रमाणपत्र और प्रकाशित अंक की प्रति",
        "यूजीसी-केयर और अन्य प्रमुख इंडेक्सिंग मानकों का अनुपालन",
        "अंतरराष्ट्रीय लेखकों के लिए बहुभाषी सहायता"
      ]
    },
    partners: {
      title: "इंडेक्सिंग और हमारे सहयोगी"
    },
    faqs: {
      title: "अक्सर पूछे जाने वाले प्रश्न (FAQ)",
      list: [
        {
          question: "मैं अपना शोध पत्र एआरसी पब्लिकेशन में कैसे जमा कर सकता/सकती हूं?",
          answer:
            "आप एआरसी पब्लिकेशन जर्नल द्वारा दी गई आधिकारिक सबमिशन प्रक्रिया के माध्यम से अपना शोध पत्र जमा कर सकते हैं।"
        },
        {
          question: "एआरसी पब्लिकेशन किस प्रकार के शोध स्वीकार करता है?",
          answer:
            "एआरसी पब्लिकेशन मौलिक शोध, समीक्षा पत्र और अन्य ऐसे शोध कार्य स्वीकार करता है, जो संबंधित जर्नल के विषय क्षेत्र से मेल खाते हों।"
        },
        {
          question: "एआरसी पब्लिकेशन में सहकर्मी समीक्षा प्रक्रिया कैसे काम करती है?",
          answer:
            "सबसे पहले संपादक आपके शोध पत्र की जांच करता है। इसके बाद विषय विशेषज्ञ डबल-ब्लाइंड सहकर्मी समीक्षा प्रक्रिया के माध्यम से उसकी समीक्षा करते हैं।"
        },
        {
          question: "एआरसी पब्लिकेशन को शोध पत्र प्रकाशित करने में कितना समय लगता है?",
          answer:
            "समय जर्नल, समीक्षा प्रक्रिया, लेखक द्वारा किए गए संशोधनों और अंतिम संपादकीय निर्णय पर निर्भर करता है।"
        },
        {
          question: "क्या एआरसी पब्लिकेशन ओपन-एक्सेस प्रकाशन प्रदान करता है?",
          answer:
            "हां, एआरसी पब्लिकेशन ओपन-एक्सेस प्रकाशन प्रदान करता है, जिससे पाठक प्रकाशित शोध को आसानी से पढ़ और प्राप्त कर सकते हैं।"
        },
        {
          question:
            "मैं कैसे जांच सकता/सकती हूं कि मेरा शोध एआरसी पब्लिकेशन के किसी जर्नल के लिए उपयुक्त है या नहीं?",
          answer:
            "अपना शोध पत्र जमा करने से पहले जर्नल के विषय क्षेत्र, दायरे और लेखक दिशानिर्देशों की जांच करें।"
        },
        {
          question: "एआरसी पब्लिकेशन लेखकों को किस प्रकार की सहायता प्रदान करता है?",
          answer:
            "एआरसी पब्लिकेशन भाषा संपादन, प्रूफरीडिंग, प्रारूपण, साहित्यिक चोरी की जांच, समीक्षकों की टिप्पणियों के उत्तर और चित्र तैयार करने में सहायता प्रदान करता है।"
        },
        {
          question:
            "क्या मैं ऐसी पांडुलिपि जमा कर सकता/सकती हूं जो पहले कहीं और प्रकाशित हो चुकी है?",
          answer:
            "नहीं। आपकी पांडुलिपि मौलिक होनी चाहिए और एक ही समय में किसी अन्य जर्नल में प्रकाशित या प्रकाशन के लिए प्रस्तुत नहीं की जानी चाहिए।"
        },
        {
          question:
            "क्या एआरसी पब्लिकेशन पांडुलिपियों की साहित्यिक चोरी की जांच करता है?",
          answer:
            "हां, एआरसी पब्लिकेशन शोध की गुणवत्ता और मौलिकता बनाए रखने में सहायता के लिए साहित्यिक चोरी और समानता की जांच की सुविधा प्रदान करता है।"
        },
        {
          question:
            "क्या लेखक पांडुलिपि के प्रारूपण में सहायता का अनुरोध कर सकते हैं?",
          answer:
            "हां, लेखक अपनी पांडुलिपि को जर्नल की आवश्यकताओं के अनुसार तैयार करने के लिए प्रारूपण संबंधी सहायता प्राप्त कर सकते हैं।"
        }
      ]
    },
    footer: {
      tagline: "शैक्षणिक प्रकाशन में अनुसंधान और सहयोग को आगे बढ़ाना",
      quickLinks: "त्वरित लिंक",
      aboutUs: "हमारे बारे में",
      guidelines: "दिशानिर्देश",
      policies: "नीतियां",
      contactUs: "संपर्क करें",
      submitPaper: "पेपर जमा करें",
      address: "कार्यालय संख्या 118, शेख महरा-अल, कुसैस बिल्डिंग, अल कुसैस सेकेंड, दुबई, 00000, दुबई",
      letsChat: "बातचीत करें",
      haveQuestion: "क्या आपके पास कोई सहायता संबंधी प्रश्न है?",
      getInTouch: "संपर्क में रहें",
      copyright: "© 2026 आर्क पब्लिकेशन सर्विसेज एलएलसी। सर्वाधिकार सुरक्षित।"
    }
  },

  es: {
    nav: {
      home: "Inicio",
      about: "Sobre Nosotros",
      journals: "Nuestras Revistas",
      procedure: "Proceso de Publicación",
      benefits: "Beneficios",
      guidelines: "Directrices",
      policies: "Políticas",
      contact: "Contacto",
      contactBtn: "Contacto",
      contactMobile: "Contacto",
      editorialOffice: "Contactar a la Oficina Editorial",
      selectLanguage: "Seleccionar Idioma",
      navigation: "Navegación",
      fastTrack: "Revisión Ágil por Pares"
    },
    hero: {
      trustPill: "Editorial con Revisión por Pares y Acceso Abierto",
      titleMain: "Publique su Investigación con",
      titleAccent: "Impacto Global",
      titleEnd: "y Confianza",
      subtitle: "Únase a miles de autores e investigadores internacionales que confían en nuestras revistas científicas. Experimente una revisión por pares rápida, asignación de DOI e indexación global.",
      contactBtn: "Contactar a la Oficina Editorial",
      browseBtn: "Explorar Revistas",
      stats: {
        journals: "Revistas Científicas",
        countries: "Países Alcanzados",
        review: "Revisión Ágil",
        openAccess: "Acceso Abierto"
      }
    },
    about: {
      sectionTitle: "Sobre Nosotros",

      highlight:
        "ARC Servicios de Publicación LLC es una editorial independiente dedicada a facilitar a investigadores, académicos y profesionales la publicación de sus investigaciones de calidad.",

      description1:
        "Ofrecemos una variedad de medios de publicación de acceso abierto y revisados por pares. Con un compromiso con la conducta ética, la transparencia, la integridad académica y la accesibilidad, ARC ayuda a que investigaciones importantes lleguen a audiencias académicas más amplias,",

      description2:
        "promoviendo así el intercambio de conocimientos."
    },
    mission: {
      title: "Nuestra Misión",
      points: [
        "Mantener la excelencia en la publicación académica.",
        "Mantener la integridad en el proceso de revisión por pares.",
        "Proporcionar a los investigadores una excelente plataforma para publicar.",
        "Promover investigaciones de calidad y valiosas en todo el mundo."
      ]
    },
    vision: {
      title: "Nuestra Visión",
      points: [
        "Ser una editorial académica internacional creíble y respetada.",
        "Fomentar el aprendizaje permanente y la investigación.",
        "Hacer que la investigación académica sea más accesible y visible.",
        "Forjar relaciones académicas más allá de las fronteras."
      ]
    },
    areasCovered: {
      badge: "Áreas Académicas",
      titleMain: "Áreas que",
      titleAccent: "Cubrimos",
      intro: "ARC Servicios de Publicación LLC ofrece a investigadores, académicos y profesionales una forma de publicar sus trabajos de investigación mediante un medio de acceso abierto. Nuestro repertorio en expansión incluye contribuciones procedentes de diversos campos académicos que han sido útiles para realizar contribuciones únicas a la innovación y al intercambio de conocimientos.",
      items: [
        {
          title: "Ciencias de la Salud y Ciencias Médicas",
          description: "Estudios relacionados con las ciencias médicas, la atención sanitaria, la medicina, las enfermedades, las terapias y los avances dentro del campo de las ciencias de la salud."
        },
        {
          title: "Nefrología y Urología",
          description: "Estudios centrados en los riñones, las enfermedades renales, la urología y los avances en los campos de la nefrología y la urología."
        },
        {
          title: "Ciencias Aplicadas",
          description: "Estudios relacionados con la aplicación de la ciencia, los descubrimientos, los avances tecnológicos y las soluciones a problemas prácticos."
        },
        {
          title: "Ciencias Naturales",
          description: "Estudios relacionados con la investigación científica, los descubrimientos y los avances que conducen a una mayor comprensión del mundo natural."
        },
        {
          title: "Educación y Estudios Educativos",
          description: "Estudios relacionados con la teoría educativa, la pedagogía, la educación, las políticas, el desarrollo y los nuevos desafíos en el ámbito educativo."
        },
        {
          title: "Investigación Interdisciplinaria",
          description: "Investigación que involucra múltiples disciplinas académicas para formar perspectivas amplias y resolver problemas de manera creativa."
        },
        {
          title: "Investigación Multidisciplinaria",
          description: "Investigación que integra diferentes disciplinas académicas para facilitar la colaboración y el intercambio de conocimientos."
        },
        {
          title: "Campos de Investigación Emergentes",
          description: "La investigación innovadora en nuevos campos que contribuye al progreso científico, académico, profesional y social es bienvenida en ARC Servicios de Publicación LLC."
        }
      ],
      statementTitle: "Diversos Formatos de Investigación",
      statementText1: "Nos complace publicar nuevas contribuciones de investigación en todas nuestras revistas, que pueden ser investigaciones teóricas, empíricas, de revisión, aplicadas o investigaciones que presenten nuevas ideas, conocimientos prácticos y contribuciones académicas.",
      statementText2: "ARC Servicios de Publicación LLC es una plataforma académica de acceso abierto donde los académicos intercambian información, establecen referencias cruzadas entre ideas y promueven el progreso de la academia.",
      inquireBtn: "Enviar / Consultar Ahora"
    },
    ourJournal: {
      title: "Nuestras Revistas",
      intro: "ARC Publication Services LLC alberga una cartera creciente de revistas revisadas por pares que abarcan múltiples disciplinas académicas. Cada revista está guiada por comités editoriales expertos e indexada en bases de datos líderes para maximizar la visibilidad y el impacto.",
      provideTitle: "Nuestras revistas ofrecen:",
      provideList: [
        "Rigurosa revisión por pares a doble ciego",
        "Asignación de DOI para todos los artículos",
        "Acceso abierto para lectores de todo el mundo",
        "Oportunidades para números especiales y colaboraciones en congresos"
      ],
      closing: "Ya sea profesor, investigador o profesional de la industria, nuestras revistas son la plataforma adecuada para difundir su trabajo.",
      moreJournals: "Más Revistas",
      viewJournal: "Ver Revista",
      submitPaper: "Enviar Artículo"
    },

    procedure: {
      title: "Nuestro Proceso de Publicación",
      subtitle: "Un camino transparente desde el envío del manuscrito hasta la publicación académica.",
      steps: [
        {
          title: "Envío del Manuscrito",
          description: "Los autores presentan sus trabajos de investigación de acuerdo con las directrices establecidas, junto con la documentación necesaria."
        },
        {
          title: "Evaluación Editorial",
          description: "El consejo editorial revisa el trabajo presentado para determinar su relevancia, calidad, formato, originalidad y adecuación para la revisión por pares."
        },
        {
          title: "Revisión por Pares Doble Ciego",
          description: "El trabajo pasa por un proceso de evaluación realizado por expertos en la materia mediante una revisión por pares doble ciego para comprobar la originalidad y la calidad académica del trabajo."
        },
        {
          title: "Revisiones y Decisión",
          description: "El autor considera los comentarios de los revisores y realiza las revisiones necesarias en el trabajo. Después de revisar el manuscrito, los editores toman una decisión final sobre su publicación."
        },
        {
          title: "Publicación y Accesibilidad",
          description: "Cuando el trabajo es aceptado, pasa por el proceso de publicación y queda accesible para todos."
        }
      ],
      comprehensiveSupport: {
        title: "Servicios de Soporte Integral",
        col1: [
          "Servicios de edición lingüística y corrección de estilo",
          "Detección de plagio e informes de similitud",
          "Asistencia de formateo según las normas de la revista"
        ],
        col2: [
          "Orientación experta para responder a los revisores",
          "Preparación profesional de figuras e ilustraciones",
          "Seguimiento de impacto y analíticas post-publicación"
        ]
      }
    },
    benefits: {
      title: "Beneficios de Publicar con Nosotros",
      subtitle: "Por qué los investigadores eligen ARC Publication Services LLC",
      list: [
        "Proceso de revisión por pares transparente y justo por expertos internacionales",
        "Publicación rigurosa con tiempos de respuesta reducidos",
        "Indexación internacional en bases de datos destacadas",
        "Asistencia y soporte dedicado para autores en cada etapa",
        "Acceso Abierto con licencias Creative Commons para máxima visibilidad",
        "Edición de lenguaje profesional y servicios de maquetación",
        "Asignación de Identificador de Objeto Digital (DOI)",
        "Plataforma multidisciplinaria para diversas áreas científicas",
        "Publicación regular para una pronta difusión del conocimiento",
        "Tarifas de procesamiento transparentes sin costos ocultos",
        "Lectores globales y mayor potencial de citaciones",
        "Certificado electrónico gratuito y ejemplar del artículo",
        "Cumplimiento de estándares de indexación internacionales",
        "Soporte multilingüe para autores de todo el mundo"
      ]
    },
    partners: {
      title: "Indexaciones y Socios Académicos"
    },
    faqs: {
      title: "Preguntas Frecuentes",
      list: [
        {
          question: "¿Cómo puedo enviar mi trabajo de investigación a ARC Publicación?",
          answer: "Puede enviar su trabajo mediante el método oficial de envío indicado por la revista de ARC Publicación."
        },
        {
          question: "¿Qué tipos de investigación acepta ARC Publicación?",
          answer: "ARC Publicación acepta investigaciones originales, artículos de revisión y otros trabajos de investigación que coincidan con el área temática de la revista."
        },
        {
          question: "¿Cómo funciona el proceso de revisión por pares en ARC Publicación?",
          answer: "Primero, el editor revisa su trabajo. Después, los expertos lo evalúan mediante un proceso de revisión por pares doble ciego."
        },
        {
          question: "¿Cuánto tiempo tarda ARC Publicación en publicar un trabajo de investigación?",
          answer: "El tiempo depende de la revista, el proceso de revisión, las revisiones realizadas por los autores y la decisión editorial final."
        },
        {
          question: "¿ARC Publicación ofrece publicación de acceso abierto?",
          answer: "Sí, ARC Publicación ofrece publicación de acceso abierto para que los lectores puedan acceder fácilmente a las investigaciones publicadas."
        },
        {
          question: "¿Cómo puedo comprobar si mi investigación es adecuada para una revista de ARC Publicación?",
          answer: "Revise el área temática, el alcance y las directrices para autores de la revista antes de enviar su trabajo."
        },
        {
          question: "¿Qué apoyo ofrece ARC Publicación a los autores?",
          answer: "ARC Publicación ofrece ayuda con la edición lingüística, corrección de textos, formato, comprobación de plagio, respuestas a revisores y preparación de figuras."
        },
        {
          question: "¿Puedo enviar un manuscrito que haya sido publicado en otro lugar?",
          answer: "No. Su manuscrito debe ser original y no debe haber sido publicado ni enviado para publicación en otra revista al mismo tiempo."
        },
        {
          question: "¿ARC Publicación comprueba los manuscritos para detectar plagio?",
          answer: "Sí, ARC Publicación ofrece comprobación de plagio y similitud para ayudar a mantener la calidad y originalidad de la investigación."
        },
        {
          question: "¿Pueden los autores solicitar ayuda con el formato del manuscrito?",
          answer: "Sí, los autores pueden recibir asistencia con el formato para preparar su manuscrito de acuerdo con los requisitos de la revista."
        }
      ]
    },
    footer: {
      tagline: "Avanzando en la Investigación y Colaboración en la Publicación Académica",
      quickLinks: "Enlaces Rápidos",
      aboutUs: "Sobre Nosotros",
      guidelines: "Directrices",
      policies: "Políticas",
      contactUs: "Contacto",
      submitPaper: "Enviar Artículo",
      address: "Oficina N° 118, SHAIKHA MHARA-AL, EDIFICIO QUSAIS, Al Qusais Second, Dubái, 00000, Dubái",
      letsChat: "Conversemos",
      haveQuestion: "¿Tiene alguna duda o consulta?",
      getInTouch: "Ponerse en Contacto",
      copyright: "© 2026 Arc Publication Services LLC. Todos los derechos reservados."
    }
  },

  ta: {
    nav: {
      home: "முகப்பு",
      about: "எங்களைப் பற்றி",
      journals: "எங்கள் இதழ்கள்",
      procedure: "வெளியீட்டு செயல்முறை",
      benefits: "நன்மைகள்",
      guidelines: "வழிகாட்டுதல்கள்",
      policies: "கொள்கைகள்",
      contact: "தொடர்பு கொள்ள",
      contactBtn: "தொடர்பு கொள்ள",
      contactMobile: "தொடர்பு",
      editorialOffice: "ஆசிரியர் அலுவலகத்தைத் தொடர்பு கொள்ளவும்",
      selectLanguage: "மொழியைத் தேர்ந்தெடுக்கவும்",
      navigation: "வழிகாட்டி",
      fastTrack: "விரைவான சக மதிப்பாய்வு"
    },
    hero: {
      trustPill: "மதிப்பாய்வு செய்யப்பட்ட & திறந்த அணுகல் பதிப்பகம்",
      titleMain: "உங்கள் ஆராய்ச்சியை",
      titleAccent: "உலகளாவிய தாக்கத்துடன்",
      titleEnd: "வெளியிடுங்கள்",
      subtitle: "எங்கள் சர்வதேச சக மதிப்பாய்வு இதழ்களை நம்பும் ஆயிரக்கணக்கான உலகளாவிய ஆராய்ச்சியாளர்களுடன் இணையுங்கள். விரைவான மதிப்பாய்வு, DOI மற்றும் உலகளாவிய அட்டவணைப்படுத்தலைப் பெறுங்கள்.",
      contactBtn: "ஆசிரியர் அலுவலகத்தைத் தொடர்பு கொள்ளவும்",
      browseBtn: "எங்கள் இதழ்களைப் பார்க்கவும்",
      stats: {
        journals: "ஆராய்ச்சி இதழ்கள்",
        countries: "அடைந்த நாடுகள்",
        review: "விரைவான மதிப்பாய்வு",
        openAccess: "திறந்த அணுகல்"
      }
    },
    about: {
      sectionTitle: "எங்களைப் பற்றி",

      highlight:
        "ARC பப்ளிகேஷன் சர்வீசஸ் எல்எல்சி என்பது ஆராய்ச்சியாளர்கள், கல்வியாளர்கள் மற்றும் நிபுணர்கள் தங்களின் தரமான ஆராய்ச்சியை வெளியிடுவதற்கு உதவுவதற்காக அர்ப்பணிக்கப்பட்ட ஒரு சுயாதீன பதிப்பகம் ஆகும்.",

      description1:
        "சக மதிப்பாய்வு செய்யப்பட்ட திறந்த அணுகல் வெளியீட்டு தளங்களை நாங்கள் வழங்குகிறோம். நெறிமுறை நடத்தை, வெளிப்படைத்தன்மை, கல்வியியல் நேர்மை மற்றும் அணுகல்தன்மை ஆகியவற்றில் நாங்கள் கொண்டுள்ள உறுதிப்பாட்டின் மூலம், முக்கியமான ஆராய்ச்சிகள் பரந்த கல்வியியல் பார்வையாளர்களை சென்றடைய ARC உதவுகிறது.",

      description2:
        "இதன் மூலம் அறிவுப் பரிமாற்றத்தை ஊக்குவிக்கிறது."
    },
    mission: {
      title: "எங்கள் நோக்கம்",
      points: [
        "கல்வியியல் வெளியீட்டில் சிறப்பை நிலைநிறுத்துதல்.",
        "சக மதிப்பாய்வு செயல்முறையில் நேர்மையைப் பேணுதல்.",
        "ஆராய்ச்சியாளர்களுக்கு வெளியிடுவதற்கான சிறந்த தளத்தை வழங்குதல்.",
        "உலகம் முழுவதும் தரமான ஆராய்ச்சியை ஊக்குவித்தல்."
      ]
    },
    vision: {
      title: "எங்கள் தொலைநோக்கு",
      points: [
        "நம்பகமான மற்றும் மதிப்புமிக்க சர்வதேச கல்வியியல் பதிப்பகமாக இருப்பது.",
        "வாழ்நாள் முழுவதும் கற்றல் மற்றும் ஆராய்ச்சியை ஊக்குவித்தல்.",
        "கல்வியியல் ஆராய்ச்சியை மேலும் அணுகக்கூடியதாகவும் காணக்கூடியதாகவும் மாற்றுதல்.",
        "எல்லைகளைக் கடந்து கல்வியியல் உறவுகளை உருவாக்குதல்."
      ]
    },
    areasCovered: {
      badge: "கல்விப் பிரிவுகள்",
      titleMain: "நாங்கள் உள்ளடக்கிய",
      titleAccent: "துறைகள்",
      intro: "ARC பப்ளிகேஷன் சர்வீசஸ் எல்எல்சி ஆராய்ச்சியாளர்கள், கல்வியாளர்கள் மற்றும் நிபுணர்கள் தங்களின் ஆராய்ச்சிப் பணிகளை திறந்த அணுகல் முறையின் மூலம் வெளியிடுவதற்கான வாய்ப்பை வழங்குகிறது. எங்களின் விரிவடைந்து வரும் வெளியீட்டு துறைகளில் கல்வியியல் பல்வேறு துறைகளிலிருந்து பெறப்படும் பங்களிப்புகள் இடம்பெறுகின்றன. இவை புதுமை மற்றும் அறிவுப் பகிர்வில் தனித்துவமான பங்களிப்புகளை உருவாக்க உதவுகின்றன.",
      items: [
        {
          title: "சுகாதாரம் மற்றும் மருத்துவ அறிவியல்",
          description: "மருத்துவம், சுகாதாரப் பாதுகாப்பு, நோய்கள், சிகிச்சைகள் மற்றும் மருத்துவத்துறை முன்னேற்றங்கள் பற்றிய ஆய்வுகள்."
        },
        {
          title: "சிறுநீரகவியல் மற்றும் யூரோலஜி",
          description: "சிறுநீரகங்கள், சிறுநீரக நோய்கள் மற்றும் அவை தொடர்பான அறிவியல் முன்னேற்றங்கள் பற்றிய ஆய்வுகள்."
        },
        {
          title: "பயன்பாட்டு அறிவியல் (Applied Sciences)",
          description: "அறிவியல் கண்டுபிடிப்புகள், தொழில்நுட்ப முன்னேற்றங்கள் மற்றும் நடைமுறை தீர்வுகளை நோக்கிய ஆய்வுகள்."
        },
        {
          title: "இயற்கை அறிவியல் (Natural Sciences)",
          description: "இயற்கை உலகைப் பற்றிய ஆழமான புரிதலுக்கு வழிவகுக்கும் அறிவியல் கண்டுபிடிப்புகள் மற்றும் ஆய்வுகள்."
        },
        {
          title: "கல்வி மற்றும் கல்விசார் ஆய்வுகள்",
          description: "கற்பித்தல் கோட்பாடுகள், கல்வி வழிகாட்டல், கல்வி கொள்கைகள் மற்றும் புதிய சவால்கள் பற்றிய ஆய்வுகள்."
        },
        {
          title: "துறைசார் ஒருங்கிணைந்த ஆராய்ச்சி (Interdisciplinary)",
          description: "பிரச்சினைகளுக்குப் புதுமையான தீர்வு காண பல கல்விப் பிரிவுகளை இணைக்கும் விரிவான ஆராய்ச்சி."
        },
        {
          title: "பல்துறை ஆராய்ச்சி (Multidisciplinary)",
          description: "கல்வி ஒத்துழைப்பு மற்றும் அறிவுப் பரிமாற்றத்தை எளிதாக்க பல்வேறு துறைகளை ஒருங்கிணைக்கும் ஆய்வு."
        },
        {
          title: "வளர்ந்து வரும் ஆராய்ச்சித் துறைகள்",
          description: "அறிவியல், கல்வி மற்றும் சமூக முன்னேற்றத்திற்கு உதவும் புதிய துறைகளில் புதுமையான ஆய்வுகள்."
        }
      ],
      statementTitle: "பல்வேறு ஆய்வு வடிவங்கள் வரவேற்கப்படுகின்றன",
      statementText1: "கோட்பாட்டு, பரிசோதனை, மறுஆய்வு அல்லது புதிய யோசனைகளை முன்வைக்கும் அனைத்து ஆய்வுப் பங்களிப்புகளையும் நாங்கள் வெளியிடுகிறோம்.",
      statementText2: "ஆர்க் பப்ளிகேஷன் என்பது கல்வியாளர்கள் தகவல்களைப் பரிமாறிக்கொண்டு கல்வியின் வளர்ச்சியை ஊக்குவிக்கும் திறந்த தளமாகும்.",
      inquireBtn: "சமர்ப்பிக்க / விசாரிக்க"
    },
    ourJournal: {
      title: "எங்கள் இதழ்கள்",
      intro: "ARC பப்ளிகேஷன் சர்வீசஸ் எல்எல்சி பல கல்விப் பிரிவுகளை உள்ளடக்கிய சக மதிப்பாய்வு செய்யப்பட்ட இதழ்களின் வளர்ந்து வரும் தொகுப்பை வழங்குகிறது. ஒவ்வொரு இதழும் நிபுணர் ஆசிரியர் குழுக்களால் வழிநடத்தப்பட்டு, பார்வைத்திறன் மற்றும் தாக்கத்தை அதிகரிக்க முன்னணி தரவுத்தளங்களில் குறியிடப்படுகிறது.",
      provideTitle: "எங்கள் இதழ்கள் வழங்குபவை:",
      provideList: [
        "கடுமையான இரட்டை மறைமுக சக மதிப்பாய்வு",
        "அனைத்து ஆய்வுக் கட்டுரைகளுக்கும் DOI ஒதுக்கீடு",
        "உலகளாவிய வாசகர்களுக்கான திறந்த அணுகல்",
        "சிறப்பு இதழ்கள் மற்றும் மாநாட்டு ஒத்துழைப்புகளுக்கான வாய்ப்புகள்"
      ],
      closing: "நீங்கள் பேராசிரியராகவோ, ஆராய்ச்சியாளராகவோ அல்லது தொழில்முறை வல்லுநராகவோ இருந்தாலும், உங்கள் படைப்புகளை வெளிப்படுத்த எங்கள் இதழ்கள் சரியான தளமாகும்.",
      moreJournals: "கூடுதல் இதழ்கள்",
      viewJournal: "இதழைப் பார்க்க",
      submitPaper: "ஆய்வை சமர்ப்பிக்க"
    },
    procedure: {
      title: "எங்கள் வெளியீட்டு செயல்முறை",

      subtitle:
        "கையெழுத்துப் பிரதியை சமர்ப்பிப்பது முதல் கல்வியியல் வெளியீடு வரை ஒரு வெளிப்படையான பாதை.",

      steps: [
        {
          title: "கையெழுத்துப் பிரதியை சமர்ப்பித்தல்",

          description:
            "ஆசிரியர்கள் நிர்ணயிக்கப்பட்ட வழிகாட்டுதல்களின்படி தேவையான ஆவணங்களுடன் தங்கள் ஆராய்ச்சிக் கட்டுரைகளை சமர்ப்பிக்கின்றனர்."
        },

        {
          title: "ஆசிரியர் குழு பரிசீலனை",

          description:
            "சமர்ப்பிக்கப்பட்ட கட்டுரையின் பொருத்தம், தரம், வடிவமைப்பு, அசல் தன்மை மற்றும் சக மதிப்பாய்வுக்கு ஏற்றதா என்பதை ஆசிரியர் குழு மதிப்பாய்வு செய்கிறது."
        },

        {
          title: "இரட்டை மறைமுக சக மதிப்பாய்வு",

          description:
            "கட்டுரையின் அசல் தன்மை மற்றும் கல்வியியல் தரத்தைச் சரிபார்க்க, சம்பந்தப்பட்ட துறை நிபுணர்களால் இரட்டை மறைமுக சக மதிப்பாய்வு முறையில் கட்டுரை மதிப்பீடு செய்யப்படுகிறது."
        },

        {
          title: "திருத்தங்கள் மற்றும் முடிவு",

          description:
            "ஆசிரியர் மதிப்பாய்வாளர்களின் கருத்துகளைப் பரிசீலித்து, கட்டுரையில் தேவையான திருத்தங்களைச் செய்கிறார். கட்டுரை திருத்தப்பட்ட பிறகு, அதன் வெளியீடு தொடர்பாக ஆசிரியர்கள் இறுதி முடிவை எடுக்கின்றனர்."
        },

        {
          title: "வெளியீடு மற்றும் அணுகல்",

          description:
            "கட்டுரை ஏற்றுக்கொள்ளப்பட்டதும், அது வெளியீட்டு செயல்முறைக்கு உட்படுத்தப்பட்டு அனைவருக்கும் அணுகக்கூடியதாகிறது."
        }
      ],
      comprehensiveSupport: {
        title: "முழுமையான ஆதரவு சேவைகள்",
        col1: [
          "மொழி திருத்தம் மற்றும் பிழை திருத்தும் சேவைகள்",
          "கருத்துத் திருட்டு சரிபார்ப்பு மற்றும் ஒற்றுமை அறிக்கைகள்",
          "இதழ் வழிகாட்டுதல்களுக்கு ஏற்ப வடிவமைப்பு உதவி"
        ],
        col2: [
          "மதிப்பாய்வாளர்களின் கருத்துகளுக்கு பதிலளிக்க நிபுணர் வழிகாட்டுதல்",
          "தொழில்முறை விளக்கப்படங்கள் மற்றும் வரைபடங்களை உருவாக்குதல்",
          "வெளியீட்டிற்குப் பிந்தைய தாக்க கண்காணிப்பு மற்றும் பகுப்பாய்வு"
        ]
      }
    },
    benefits: {
      title: "எங்களுடன் வெளியிடுவதன் நன்மைகள்",
      subtitle: "உலகெங்கிலும் உள்ள ஆராய்ச்சியாளர்கள் எங்களை ஏன் தேர்வு செய்கிறார்கள்",
      list: [
        "சர்வதேச நிபுணர்களின் நியாயமான மற்றும் வெளிப்படையான மதிப்பாய்வு",
        "விரைவான மற்றும் தரமான வெளியீட்டு செயல்முறை",
        "முக்கிய சர்வதேச தரவுத்தளங்களில் அட்டவணைப்படுத்தல்",
        "வெளியீட்டின் ஒவ்வொரு கட்டத்திலும் அர்ப்பணிப்புள்ள ஆசிரியர் ஆதரவு",
        "அதிகபட்ச பார்வைக்கு கிரியேட்டிவ் காமன்ஸ் திறந்த அணுகல்",
        "தொழில்முறை மொழி திருத்தம் மற்றும் வடிவமைப்பு சேவைகள்",
        "ஒவ்வொரு கட்டுரைக்கும் பிரத்யேக DOI எண்",
        "பல்வேறு துறைகளை உள்ளடக்கிய பல்துறை தளம்",
        "ஆராய்ச்சிகளை உடனுக்குடன் கொண்டு சேர்க்க மாதாந்திர வெளியீடு",
        "மறைமுக கட்டணங்கள் இல்லாத வெளிப்படையான கட்டண அமைப்பு",
        "உலகளாவிய வாசகர்கள் மற்றும் அதிக மேற்கோள் சாத்தியங்கள்",
        "இலவச மின்னணு சான்றிதழ் மற்றும் ஆய்விதழ் நகல்",
        "சர்வதேச கல்வி வழிகாட்டல்களுக்கு இணங்குதல்",
        "சர்வதேச ஆசிரியர்களுக்கான பன்மொழி ஆதரவு"
      ]
    },
    partners: {
      title: "அட்டவணைப்படுத்தல் மற்றும் கூட்டாளர்கள்"
    },
    faqs: {
      title: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
      list: [
        {
          question: "எனது ஆராய்ச்சிக் கட்டுரையை ARC பப்ளிகேஷன்-க்கு எவ்வாறு சமர்ப்பிப்பது?",
          answer:
            "ARC Publication இதழால் வழங்கப்பட்ட அதிகாரப்பூர்வ சமர்ப்பிப்பு முறையின் மூலம் உங்கள் கட்டுரையை சமர்ப்பிக்கலாம்."
        },

        {
          question: "ARC பப்ளிகேஷன் எந்த வகையான ஆராய்ச்சிகளை ஏற்றுக்கொள்கிறது?",
          answer:
            "ARC Publication அசல் ஆராய்ச்சிகள், மதிப்பாய்வு கட்டுரைகள் மற்றும் இதழின் பாடப்பிரிவுடன் பொருந்தக்கூடிய பிற ஆராய்ச்சிப் படைப்புகளை ஏற்றுக்கொள்கிறது."
        },

        {
          question: "ARC பப்ளிகேஷன்-ல் சக மதிப்பாய்வு செயல்முறை எவ்வாறு நடைபெறுகிறது?",
          answer:
            "முதலில் ஆசிரியர் உங்கள் கட்டுரையைச் சரிபார்க்கிறார். பின்னர் நிபுணர்கள் இரட்டை மறைமுக சக மதிப்பாய்வு செயல்முறையின் மூலம் அதை மதிப்பாய்வு செய்கிறார்கள்."
        },

        {
          question: "ARC பப்ளிகேஷன் ஒரு ஆராய்ச்சிக் கட்டுரையை வெளியிட எவ்வளவு காலம் எடுத்துக்கொள்கிறது?",
          answer:
            "நேரம் இதழ், மதிப்பாய்வு செயல்முறை, ஆசிரியர் மேற்கொள்ளும் திருத்தங்கள் மற்றும் இறுதி ஆசிரியர் குழு முடிவு ஆகியவற்றைப் பொறுத்தது."
        },

        {
          question: "ARC பப்ளிகேஷன் திறந்த அணுகல் வெளியீட்டை வழங்குகிறதா?",
          answer:
            "ஆம், ARC பப்ளிகேஷன் திறந்த அணுகல் வெளியீட்டை வழங்குகிறது. இதன் மூலம் வாசகர்கள் வெளியிடப்பட்ட ஆராய்ச்சிகளை எளிதாக அணுக முடியும்."
        },

        {
          question: "எனது ஆராய்ச்சி ARC பப்ளிகேஷன் இதழுக்கு ஏற்றதா என்பதை நான் எவ்வாறு சரிபார்க்கலாம்?",
          answer:
            "உங்கள் கட்டுரையைச் சமர்ப்பிப்பதற்கு முன் இதழின் பாடப்பிரிவு, வரம்பு மற்றும் ஆசிரியர் வழிகாட்டுதல்களைச் சரிபார்க்கவும்."
        },

        {
          question: "ARC பப்ளிகேஷன் ஆசிரியர்களுக்கு என்ன ஆதரவை வழங்குகிறது?",
          answer:
            "ARC Publication மொழி திருத்தம், சரிபார்த்தல், வடிவமைப்பு, கருத்துத் திருட்டு சரிபார்ப்பு, மதிப்பாய்வாளர்களின் கருத்துகளுக்கான பதில்கள் மற்றும் படத் தயாரிப்பு ஆகியவற்றில் உதவி வழங்குகிறது."
        },

        {
          question: "வேறு இடத்தில் ஏற்கனவே வெளியிடப்பட்ட கையெழுத்துப் பிரதியை நான் சமர்ப்பிக்கலாமா?",
          answer:
            "இல்லை. உங்கள் கையெழுத்துப் பிரதி அசலானதாக இருக்க வேண்டும். மேலும், அது ஒரே நேரத்தில் வேறு இதழில் வெளியிடப்பட்டிருக்கவோ அல்லது வெளியீட்டிற்காக சமர்ப்பிக்கப்பட்டிருக்கவோ கூடாது."
        },

        {
          question: "ARC பப்ளிகேஷன் கையெழுத்துப் பிரதிகளில் கருத்துத் திருட்டைச் சரிபார்க்கிறதா?",
          answer:
            "ஆம், ஆராய்ச்சியின் தரம் மற்றும் அசல் தன்மையைப் பராமரிக்க உதவும் வகையில் ARC பப்ளிகேஷன் கருத்துத் திருட்டு மற்றும் ஒற்றுமைச் சரிபார்ப்பை வழங்குகிறது."
        },

        {
          question: "ஆசிரியர்கள் கையெழுத்துப் பிரதியின் வடிவமைப்பிற்கான உதவியைக் கோர முடியுமா?",
          answer:
            "ஆம், இதழின் தேவைகளுக்கு ஏற்ப தங்கள் கையெழுத்துப் பிரதியைத் தயாரிக்க ஆசிரியர்கள் வடிவமைப்பு தொடர்பான உதவியைப் பெறலாம்."
        }
      ]
    },
    footer: {
      tagline: "கல்வியியல் வெளியீட்டில் ஆராய்ச்சி மற்றும் ஒத்துழைப்பை முன்னெடுத்தல்",
      quickLinks: "விரைவு இணைப்புகள்",
      aboutUs: "எங்களைப் பற்றி",
      guidelines: "வழிகாட்டுதல்கள்",
      policies: "கொள்கைகள்",
      contactUs: "தொடர்பு கொள்ள",
      submitPaper: "ஆய்வை சமர்ப்பிக்க",
      address: "அலுவலக எண் 118, ஷைகா மரா-அல், குசைஸ் கட்டிடம், அல் குசைஸ் 2, துபாய், 00000, துபாய்",
      letsChat: "உரையாடுங்கள்",
      haveQuestion: "உங்களுக்கு ஏதேனும் உதவித் தேவைப்படுகிறதா?",
      getInTouch: "தொடர்பு கொள்ளவும்",
      copyright: "© 2026 ARC பப்ளிகேஷன் சர்வீசஸ் எல்எல்சி. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை."
    }
  },

  te: {
    nav: {
      home: "హోమ్",
      about: "మా గురించి",
      journals: "మా జర్నల్స్",
      procedure: "ప్రచురణ ప్రక్రియ",
      benefits: "ప్రయోజనాలు",
      guidelines: "మార్గదర్శకాలు",
      policies: "విధానాలు",
      contact: "సంప్రదించండి",
      contactBtn: "సంప్రదించండి",
      contactMobile: "సంప్రదించండి",
      editorialOffice: "ఎడిటోరియల్ కార్యాలయాన్ని సంప్రదించండి",
      selectLanguage: "భాషను ఎంచుకోండి",
      navigation: "నావిగేషన్",
      fastTrack: "ఫాస్ట్-ట్రాక్ పీర్ సమీక్ష"
    },
    hero: {
      trustPill: "పీర్-రివ్యూడ్ & ఓపెన్ యాక్సెస్ పబ్లిషర్",
      titleMain: "మీ పరిశోధనను",
      titleAccent: "గ్లోబల్ ఇంపాక్ట్",
      titleEnd: "మరియు విశ్వాసంతో ప్రచురించండి",
      subtitle: "మా పీర్-రివ్యూడ్ జర్నల్స్‌ను విశ్వసించే వేలాది మంది అంతర్జాతీయ పరిశోధకులతో చేరండి. వేగవంతమైన డబుల్-బ్లైండ్ సమీక్ష, DOI మరియు గ్లోబల్ ఇండెక్సింగ్‌ను అనుభవించండి.",
      contactBtn: "ఎడిటోరియల్ కార్యాలయాన్ని సంప్రదించండి",
      browseBtn: "జర్నల్స్‌ను బ్రౌజ్ చేయండి",
      stats: {
        journals: "పరిశోధనా జర్నల్స్",
        countries: "చేరుకున్న దేశాలు",
        review: "వేగవంతమైన సమీక్ష",
        openAccess: "ఓపెన్ యాక్సెస్"
      }
    },
    about: {
      sectionTitle: "మా గురించి",

      highlight:
        "ARC పబ్లికేషన్ సర్వీసెస్ ఎల్‌ఎల్‌సి పరిశోధకులు, విద్యావేత్తలు మరియు నిపుణులు తమ నాణ్యమైన పరిశోధనలను ప్రచురించడానికి సహాయపడటానికి అంకితమైన ఒక స్వతంత్ర ప్రచురణ సంస్థ.",

      description1:
        "మేము పీర్-రివ్యూ చేయబడిన ఓపెన్ యాక్సెస్ ప్రచురణ వేదికలను అందిస్తున్నాము. నైతిక ప్రవర్తన, పారదర్శకత, విద్యా సమగ్రత మరియు అందుబాటుపై మా నిబద్ధత ద్వారా, ముఖ్యమైన పరిశోధనలు విస్తృతమైన విద్యా ప్రేక్షకులకు చేరుకునేలా ARC సహాయపడుతుంది.",

      description2:
        "దీని ద్వారా జ్ఞాన మార్పిడిని ప్రోత్సహిస్తుంది."
    },
    mission: {
      title: "మా లక్ష్యం (మిషన్)",

      points: [
        "విద్యా ప్రచురణలో అత్యుత్తమ ప్రమాణాలను కొనసాగించడం.",
        "పీర్ రివ్యూ ప్రక్రియలో నిజాయితీ మరియు సమగ్రతను పాటించడం.",
        "పరిశోధకులకు తమ పరిశోధనలను ప్రచురించడానికి ఉత్తమ వేదికను అందించడం.",
        "ప్రపంచవ్యాప్తంగా నాణ్యమైన మరియు విలువైన పరిశోధనను ప్రోత్సహించడం."
      ]
    },

    vision: {
      title: "మా దార్శనికత (విజన్)",

      points: [
        "విశ్వసనీయమైన మరియు గౌరవనీయమైన అంతర్జాతీయ విద్యా ప్రచురణ సంస్థగా నిలవడం.",
        "జీవితాంతం అభ్యాసం మరియు పరిశోధనను ప్రోత్సహించడం.",
        "విద్యా పరిశోధనను మరింత అందుబాటులోకి మరియు కనిపించేలా చేయడం.",
        "సరిహద్దులను దాటి విద్యా సంబంధాలను నిర్మించడం."
      ]
    },

    areasCovered: {
      badge: "విద్యా రంగాలు",

      titleMain: "మేము కవర్ చేసే",

      titleAccent: "రంగాలు",

      intro:
        "ARC పబ్లికేషన్ సర్వీసెస్ ఎల్‌ఎల్‌సి పరిశోధకులు, విద్యావేత్తలు మరియు నిపుణులు తమ పరిశోధనా పనులను ఓపెన్ యాక్సెస్ విధానం ద్వారా ప్రచురించడానికి అవకాశాన్ని అందిస్తుంది. మా విస్తరిస్తున్న ప్రచురణ రంగాలలో వివిధ విద్యా విభాగాల నుండి వచ్చే పరిశోధనా సహకారాలు ఉన్నాయి. ఇవి ఆవిష్కరణ మరియు జ్ఞాన భాగస్వామ్యానికి ప్రత్యేకమైన సహకారాలను అందించడానికి సహాయపడతాయి.",

      items: [
        {
          title: "ఆరోగ్యం మరియు వైద్య శాస్త్రాలు",

          description:
            "వైద్య శాస్త్రం, ఆరోగ్య సంరక్షణ, వైద్యం, వ్యాధులు, చికిత్సలు మరియు ఆరోగ్య శాస్త్ర రంగంలో జరుగుతున్న పురోగతులకు సంబంధించిన పరిశోధనలు."
        },

        {
          title: "నెఫ్రాలజీ మరియు యూరాలజీ",

          description:
            "మూత్రపిండాలు, మూత్రపిండ వ్యాధులు, యూరాలజీ మరియు నెఫ్రాలజీ రంగాలలో జరుగుతున్న పురోగతులపై దృష్టి సారించే పరిశోధనలు."
        },

        {
          title: "అనువర్తిత శాస్త్రాలు",

          description:
            "శాస్త్రం యొక్క అనువర్తనాలు, ఆవిష్కరణలు, సాంకేతిక పురోగతులు మరియు ఆచరణాత్మక సమస్యలకు పరిష్కారాలకు సంబంధించిన పరిశోధనలు."
        },

        {
          title: "సహజ శాస్త్రాలు",

          description:
            "సహజ ప్రపంచంపై లోతైన అవగాహనను పెంపొందించే శాస్త్రీయ పరిశోధనలు, ఆవిష్కరణలు మరియు పురోగతులకు సంబంధించిన అధ్యయనాలు."
        },

        {
          title: "విద్య మరియు విద్యాశాస్త్ర పరిశోధనలు",

          description:
            "విద్యా సిద్ధాంతం, బోధనా పద్ధతులు, విద్య, విధానాలు, అభివృద్ధి మరియు విద్యా రంగంలో ఉద్భవిస్తున్న కొత్త సవాళ్లకు సంబంధించిన పరిశోధనలు."
        },

        {
          title: "అంతరశాఖా పరిశోధన",

          description:
            "విస్తృత దృక్పథాలను అభివృద్ధి చేయడానికి మరియు సమస్యలను సృజనాత్మకంగా పరిష్కరించడానికి వివిధ విద్యా విభాగాలను కలిగి ఉండే పరిశోధన."
        },

        {
          title: "బహుళశాఖా పరిశోధన",

          description:
            "సహకారం మరియు జ్ఞాన మార్పిడిని సులభతరం చేసే విధంగా వివిధ విద్యా విభాగాలను సమగ్రపరిచే పరిశోధన."
        },

        {
          title: "అభివృద్ధి చెందుతున్న పరిశోధనా రంగాలు",

          description:
            "శాస్త్రీయ, విద్యా, వృత్తిపరమైన మరియు సామాజిక పురోగతికి దోహదపడే కొత్త రంగాలలో నిర్వహించబడే వినూత్న పరిశోధనలను ARC పబ్లికేషన్ సర్వీసెస్ ఎల్‌ఎల్‌సి స్వాగతిస్తుంది."
        }
      ],

      statementTitle: "వివిధ పరిశోధనా పత్రాలకు ఆహ్వానం",

      statementText1:
        "మా అన్ని జర్నల్స్‌లో కొత్త పరిశోధనా రచనలను ప్రచురించுவதில் మేము மகிழ்ச்சியடைகிறோம். ఇవి సిద్ధాంతపరమైన, అనుభవాధారిత, సమీక్ష ఆధారిత, అనువర్తిత పరిశోధనలు లేదా కొత్త ఆలోచనలు, ఆచరణాత్మక అవగాహనలు మరియు విద్యా సహకారాలను అందించే పరిశోధనలు కావచ్చు.",

      statementText2:
        "ARC పబ్లికేషన్ సర్వీసెస్ ఎల్‌ఎల్‌సి ఒక ఓపెన్ యాక్సెస్ విద్యా వేదిక. ఇక్కడ విద్యావేత్తలు సమాచారాన్ని పంచుకుంటారు, ఆలోచనలను పరస్పరం అనుసంధానించుకుంటారు మరియు విద్యా పురోగతిని ప్రోత్సహిస్తారు.",

      inquireBtn: "సమర్పించండి / సంప్రదించండి"
    },

    ourJournal: {
      title: "మా జర్నల్స్",
      intro: "ARC పబ్లికేషన్ సర్వీసెస్ ఎల్‌ఎల్‌సి బహుళ విద్యా విభాగాలలో విస్తరించి ఉన్న పీర్-రివ్యూడ్ జర్నల్స్‌ను నిర్వహిస్తుంది. ప్రతి జర్నల్ నిపుణులైన ఎడిటోరియల్ బోర్డుల ద్వారా మార్గనిర్దేశం చేయబడుతుంది మరియు విజిబిలిటీ, ప్రభావాన్ని పెంచడానికి ప్రముఖ డేటాబేస్‌లలో ఇండెక్స్ చేయబడింది.",
      provideTitle: "మా జర్నల్స్ అందించే ప్రయోజనాలు:",
      provideList: [
        "ఖచ్చితమైన డబుల్-బ్లైండ్ పీర్ సమీక్ష",
        "అన్ని వ్యాసాలకు DOI కేటాయింపు",
        "గ్లోబల్ పాఠకుల కోసం ఓపెన్ యాక్సెస్",
        "ప్రత్యేక సంచికలు మరియు కాన్ఫరెన్స్ భాగస్వామ్యాల అవకాశాలు"
      ],
      closing: "మీరు ప్రొఫెసర్, పరిశోధకుడు లేదా పరిశ్రమ నిపుణులైనా, మీ పరిశోధనలను ప్రదర్శించడానికి మా జర్నల్స్ సరైన వేదిక.",
      moreJournals: "మరిన్ని జర్నల్స్",
      viewJournal: "జర్నల్‌ను చూడండి",
      submitPaper: "పేపర్‌ను సమర్పించండి"
    },

    procedure: {
      title: "మా ప్రచురణ ప్రక్రియ",

      subtitle:
        "కరతప్రతిని సమర్పించడం నుండి విద్యా ప్రచురణ వరకు ఒక పారదర్శకమైన మార్గం.",

      steps: [
        {
          title: "కరతప్రతిని సమర్పించడం",

          description:
            "రచయితలు నిర్దేశించిన మార్గదర్శకాల ప్రకారం అవసరమైన పత్రాలతో తమ పరిశోధనా వ్యాసాలను సమర్పిస్తారు."
        },

        {
          title: "ఎడిటోరియల్ బోర్డు పరిశీలన",

          description:
            "సమర్పించిన వ్యాసం యొక్క సంబంధితత, నాణ్యత, ఫార్మాటింగ్, మౌలికత మరియు పీర్ రివ్యూకు అనుకూలతను ఎడిటోరియల్ బోర్డు పరిశీలిస్తుంది."
        },

        {
          title: "డబుల్-బ్లైండ్ పీర్ రివ్యూ",

          description:
            "వ్యాసం యొక్క మౌలికత మరియు విద్యా నాణ్యతను పరిశీలించడానికి సంబంధిత రంగంలోని నిపుణులు డబుల్-బ్లైండ్ పీర్ రివ్యూ విధానం ద్వారా వ్యాసాన్ని మూల్యాంకనం చేస్తారు."
        },

        {
          title: "సవరణలు మరియు నిర్ణయం",

          description:
            "రచయిత సమీక్షకుల సూచనలను పరిగణనలోకి తీసుకుని వ్యాసంలో అవసరమైన సవరణలు చేస్తారు. వ్యాసం సవరించిన తర్వాత, దాని ప్రచురణకు సంబంధించి సంపాదకులు తుది నిర్ణయం తీసుకుంటారు."
        },

        {
          title: "ప్రచురణ మరియు యాక్సెస్",

          description:
            "వ్యాసం ఆమోదించబడిన తర్వాత, అది ప్రచురణ ప్రక్రియకు లోబడి అందరికీ అందుబాటులో ఉంచబడుతుంది."
        }
      ],
      comprehensiveSupport: {
        title: "సమగ్ర సహాయ సేవలు",
        col1: [
          "భాషా సవరణ మరియు ప్రూఫ్‌రీడింగ్ సేవలు",
          "ప్లాజియారిజం తనిఖీ మరియు సిమిలారిటీ నివేదికలు",
          "జర్నల్ నిబంధనలకు అనుగుణంగా ఫార్మాటింగ్ సహాయం"
        ],
        col2: [
          "సమీక్షకుల వ్యాఖ్యలకు ప్రతిస్పందించడంలో నిపుణుల మార్గదర్శకత్వం",
          "వృత్తిపరమైన దృష్టాంతాలు మరియు చిత్రాల రూపకల్పన",
          "ప్రచురణానంతర ప్రభావ ట్రాకింగ్ మరియు విశ్లేషణలు"
        ]
      }
    },
    benefits: {
      title: "మాతో ప్రచురించడం వల్ల కలిగే ప్రయోజనాలు",
      subtitle: "ప్రపంచవ్యాప్తంగా పరిశోధకులు ఆర్క్ పబ్లికేషన్‌ను ఎందుకు ఎంచుకుంటారు",
      list: [
        "అంతర్జాతీయ నిపుణులచే పారదర్శక మరియు నిష్పాక్షికమైన సమీక్ష",
        "వేగవంతమైన మరియు నాణ్యమైన ప్రచురణ ప్రక్రియ",
        "ప్రముఖ అంతర్జాతీయ డేటాబేస్‌లలో ఇండెక్సింగ్",
        "ప్రచురణ యొక్క ప్రతి దశలో రచయితలకు పూర్తి మద్దతు",
        "గరిష్ట దృశ్యమానత కోసం క్రియేటివ్ కామన్స్ ఓపెన్ యాక్సెస్",
        "ప్రొఫెషనల్ భాషా సవరణ మరియు టైప్‌సెట్టింగ్ సేవలు",
        "ప్రతి ప్రచురించిన వ్యాసానికి డిజిటల్ ఆబ్జెక్ట్ ఐడెంటిఫైయర్ (DOI)",
        "వివిధ పరిశోధనా రంగాలను విస్తరించే మల్టీడిసిప్లినరీ ప్లాట్‌ఫారమ్",
        "పరిశోధనను త్వరితంగా వ్యాప్తి చేయడానికి నెలవారీ ప్రచురణ",
        "దాచిన రుసుములు లేని సరసమైన ప్రచురణ ఛార్జీలు",
        "ప్రపంచవ్యాప్త పాఠకులు మరియు సైటేషన్ల సంభావ్యత పెరుగుదల",
        "ఉచిత ఈ-సర్టిఫికేట్ మరియు ప్రచురిత సంచిక కాపీ",
        "అంతర్జాతీయ విద్యా ప్రమాణాలకు అనుగుణ్యత",
        "అంతర్జాతీయ రచయితల కోసం బహుభాషా సహాయం"
      ]
    },
    partners: {
      title: "ఇండెక్సింగ్ మరియు భాగస్వాములు"
    },
    faqs: {
      title: "తరచుగా అడిగే ప్రశ్నలు (FAQ)",
      list: [
        {
          question: "నా పరిశోధనా పత్రాన్ని ARC పబ్లికేషన్‌కు ఎలా సమర్పించాలి?",
          answer:
            "ARC పబ్లికేషన్ జర్నల్ అందించే అధికారిక సమర్పణ విధానం ద్వారా మీ పరిశోధనా పత్రాన్ని సమర్పించవచ్చు."
        },

        {
          question: "ARC పబ్లికేషన్ ఎలాంటి పరిశోధనలను అంగీకరిస్తుంది?",
          answer:
            "ARC పబ్లికేషన్ ఒరిజినల్ పరిశోధనలు, రివ్యూ పేపర్లు మరియు జర్నల్ యొక్క సబ్జెక్ట్ పరిధికి సరిపోయే ఇతర పరిశోధనా రచనలను అంగీకరిస్తుంది."
        },

        {
          question: "ARC పబ్లికేషన్‌లో పీర్-రివ్యూ ప్రక్రియ ఎలా జరుగుతుంది?",
          answer:
            "మొదట ఎడిటర్ మీ పరిశోధనా పత్రాన్ని పరిశీలిస్తారు. ఆ తర్వాత సంబంధిత రంగంలోని నిపుణులు డబుల్-బ్లైండ్ పీర్-రివ్యూ ప్రక్రియ ద్వారా దానిని సమీక్షిస్తారు."
        },

        {
          question: "ARC పబ్లికేషన్ ఒక పరిశోధనా పత్రాన్ని ప్రచురించడానికి ఎంత సమయం పడుతుంది?",
          answer:
            "సమయం జర్నల్, రివ్యూ ప్రక్రియ, రచయిత చేసే సవరణలు మరియు తుది ఎడిటోరియల్ నిర్ణయంపై ఆధారపడి ఉంటుంది."
        },

        {
          question: "ARC పబ్లికేషన్ ఓపెన్ యాక్సెస్ ప్రచురణను అందిస్తుందా?",
          answer:
            "అవును, ARC పబ్లికేషన్ ఓపెన్ యాక్సెస్ ప్రచురణను అందిస్తుంది. దీని ద్వారా పాఠకులు ప్రచురించబడిన పరిశోధనలను సులభంగా యాక్సెస్ చేయవచ్చు."
        },

        {
          question: "నా పరిశోధన ARC పబ్లికేషన్ జర్నల్‌కు సరిపోతుందో లేదో నేను ఎలా తనిఖీ చేయాలి?",
          answer:
            "మీ పరిశోధనా పత్రాన్ని సమర్పించే ముందు జర్నల్ యొక్క సబ్జెక్ట్ పరిధి, స్కోప్ మరియు రచయిత మార్గదర్శకాలను తనిఖీ చేయండి."
        },

        {
          question: "ARC పబ్లికేషన్ రచయితలకు ఎలాంటి సహాయాన్ని అందిస్తుంది?",
          answer:
            "ARC పబ్లికేషన్ భాషా సవరణ, ప్రూఫ్‌రీడింగ్, ఫార్మాటింగ్, ప్లాజియారిజం తనిఖీ, రివ్యూయర్ల వ్యాఖ్యలకు సమాధానాలు మరియు చిత్రాల తయారీలో సహాయం అందిస్తుంది."
        },

        {
          question: "ఇప్పటికే వేరే చోట ప్రచురించబడిన రాతప్రతిని నేను సమర్పించవచ్చా?",
          answer:
            "లేదు. మీ రాతప్రతి ఒరిజినల్ అయి ఉండాలి. అలాగే, అది ఒకేసారి మరే ఇతర జర్నల్‌లో ప్రచురించబడి ఉండకూడదు లేదా ప్రచురణ కోసం సమర్పించబడి ఉండకూడదు."
        },

        {
          question: "ARC పబ్లికేషన్ రాతప్రతుల్లో ప్లాజియారిజం తనిఖీ చేస్తుందా?",
          answer:
            "అవును, పరిశోధన యొక్క నాణ్యత మరియు ఒరిజినాలిటీని కాపాడేందుకు ARC పబ్లికేషన్ ప్లాజియారిజం మరియు సిమిలారిటీ తనిఖీని అందిస్తుంది."
        },

        {
          question: "రచయితలు రాతప్రతి ఫార్మాటింగ్ కోసం సహాయం కోరవచ్చా?",
          answer:
            "అవును, జర్నల్ అవసరాలకు అనుగుణంగా తమ రాతప్రతిని సిద్ధం చేసుకోవడానికి రచయితలు ఫార్మాటింగ్ సంబంధిత సహాయం పొందవచ్చు."
        }
      ]
    },
    footer: {
      tagline: "అకడమిక్ ప్రచురణలో పరిశోధన మరియు సహకారాన్ని ముందుకు తీసుకెళ్లడం",
      quickLinks: "త్వరిత లింకులు",
      aboutUs: "మా గురించి",
      guidelines: "మార్గదర్శకాలు",
      policies: "విధానాలు",
      contactUs: "సంప్రదించండి",
      submitPaper: "పేపర్‌ను సమర్పించండి",
      address: "ఆఫీస్ నెం 118, షైఖా మహరా-అల్, ఖుసైస్ భవనం, అల్ ఖుసైస్ 2, దుబాయ్, 00000, దుబాయ్",
      letsChat: "చర్చించండి",
      haveQuestion: "ఏదైనా సహాయం కావాలా?",
      getInTouch: "సంప్రదించండి",
      copyright: "© 2026 ARC పబ్లికేషన్ సర్వీసెస్ ఎల్‌ఎల్‌సి. సర్వహక్కులు ప్రత్యేకించబడ్డాయి."
    }
  }
};
